import React from "react";

import '../Style.css';
import minitabletop from '../Assets/Images/mini_table_top_scale.png';

import { IoIosSend } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { BiRightTopArrowCircle } from "react-icons/bi";

import Milton_Chottu_Scale from '../Assets/Images/Economic Scales/Mini Table Top Scale/Milton_Chottu_Scale.png'
import Economic_Chottu_Scale from '../Assets/Images/Economic Scales/Mini Table Top Scale//Economic_Chottu_Scale.png'
import BTB_5 from '../Assets/Images/Economic Scales/Mini Table Top Scale/BTB-5.png'
import BTB_6 from '../Assets/Images/Economic Scales/Mini Table Top Scale/BTB-6.png'
import MTB_6_Green from '../Assets/Images/Economic Scales/Mini Table Top Scale/MTB-6_Green.png'
import MTB_6 from '../Assets/Images/Economic Scales/Mini Table Top Scale/MTB-6.png'
import Micro from '../Assets/Images/Economic Scales/Mini Table Top Scale/micro.png'
import Mini_Pole from '../Assets/Images/Economic Scales/Mini Table Top Scale/Mini_Pole.png'


function Minitabletop() {
    return (
        <div>


            <section className="py-5">
                <div className="container py-lg-5">
                    <div class="mt-3">
                        <p class="section-top-heading-css py-3 py-lg-0">Minitabletop</p>

                    </div>
                    <div className="row   row-cols-lg-2 row-cols-1 min-vh-100 justify-content-center g-4 align-items-center ">

                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    Eco Mini Scale
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={Micro} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity :10  kg</p>
                                            <p className="about-card-para-css">Accuracy :1  g</p>
                                            <p className="about-card-para-css">Platter Size ( mm ) :185  x 150</p>
                                        </div>

                                        <a href="/Micro" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2 ">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    Milton Chottu Scale
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={Milton_Chottu_Scale} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity :10,20  kg</p>
                                            <p className="about-card-para-css">Accuracy :1  g</p>
                                            <p className="about-card-para-css">Platter Size ( mm ) :210 x 160 </p>
                                        </div>

                                        <a href="/Miltonchottuscale" className="text-start about-card-para-css  " >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text "><span className="underline_text ">Know More</span></span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">

                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2 ">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    Economic Chottu Scale
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={Economic_Chottu_Scale} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <div>
                                                <p className="about-card-para-css">Capacity :10,20  kg</p>
                                                <p className="about-card-para-css">Accuracy :1  g</p>
                                                <p className="about-card-para-css">Platter Size ( mm ) :210 x 160 </p>
                                            </div>
                                        </div>

                                        <a href="/Economicchottuscale" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2 ">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    MTB-6 Green
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={MTB_6_Green} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity :10/20  kg</p>
                                            <p className="about-card-para-css">Accuracy :1/2  g</p>
                                            <p className="about-card-para-css">Platter Size ( mm ) :180 x 220</p>
                                        </div>

                                        <a href="/MTB_6_green" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2 ">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    MTB-6
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={MTB_6} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity :10/20  kg</p>
                                            <p className="about-card-para-css">Accuracy :1/2  g</p>
                                            <p className="about-card-para-css">Platter Size ( mm ) :180 x 220</p>
                                        </div>

                                        <a href="/MTB_6" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2 ">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    BTB-6
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={BTB_6} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity :10/20  kg</p>
                                            <p className="about-card-para-css">Accuracy :1/2  g</p>
                                            <p className="about-card-para-css">Platter Size ( mm ) :180 x 220</p>
                                        </div>

                                        <a href="/BTB_6" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2 ">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    BTB-5
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={BTB_5} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity :10/20  kg</p>
                                            <p className="about-card-para-css">Accuracy :1/2  g</p>
                                            <p className="about-card-para-css">Platter Size ( mm ) :180 x 220</p>
                                        </div>

                                        <a href="/BTB_5" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2 ">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    Mini Pole
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={Mini_Pole} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity :10/20  kg</p>
                                            <p className="about-card-para-css">Accuracy :1/2  g</p>
                                            <p className="about-card-para-css">Platter Size ( mm ) :180 x 220</p>
                                        </div>

                                        <a href="/Minipole" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2 ">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>


                </div>
            </section>





        </div >

    );
}

export default Minitabletop;
